import cx from 'classnames';
import type { FC } from 'react';

import Btn from 'src/components-v2/Inputs/Button/Btn';
import { useCmsTheme } from 'src/contexts/CmsThemeContext/CmsThemeContextProvider';
import { usePageLocale } from 'src/contexts/LocaleContext/LocaleContext';
import { CmsThemes } from 'src/lib/constants';
import type { NavigationVariant } from 'src/lib/site-navigation';

import { navData } from './data';

import styles from './MainNavigationBar.module.scss';

/**
 * Desktop CTA cluster shared by the default and minimal navs so the buttons
 * cannot diverge.
 */
export const NavCtaButtons: FC<{ variant?: NavigationVariant }> = ({
  variant = 'default',
}) => {
  const { ctaTrackingIds } = navData[usePageLocale()];
  const cmsTheme = useCmsTheme();
  const buttonClassName = cx(styles.Button, {
    [styles.Button_legacy]: cmsTheme !== CmsThemes.WEB3,
  });
  const minimal = variant === 'minimal';

  return (
    <div
      className={cx(styles.Root__toolkit, {
        [styles.Root__toolkit_minimal]: minimal,
      })}
    >
      {!minimal && (
        <Btn
          className={buttonClassName}
          variant='secondary'
          href='https://dashboard.plaid.com/'
        >
          Log in
        </Btn>
      )}

      <Btn
        className={buttonClassName}
        variant='primary'
        iconName='ChevronRight'
        iconSize={16}
        defaultGap='0.6rem'
        href='/contact/'
        trackingId={ctaTrackingIds.getAPIkeys}
      >
        Contact sales
      </Btn>
    </div>
  );
};
